import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

// Helper function to set nested values dynamically
// Updated setNestedValue helper function with null/undefined check
export const setNestedValue = (obj, path, value) => {
	// Check if path is null or undefined
	if (path == null) {
		return value; // If no path provided, return the value itself
	}

	const keys = path.split(".");
	const newObj = JSON.parse(JSON.stringify(obj)); // Deep copy to avoid state mutation
	let current = newObj;

	for (let i = 0; i < keys.length - 1; i++) {
		const key = keys[i];

		if (!current[key] || typeof current[key] !== "object") {
			current[key] = {};
		}

		current = current[key];
	}

	current[keys[keys.length - 1]] = value;

	return newObj; // Return full new object
};



// Updated urlToArr function
export const urlToArr = () => {
	const location = useLocation();
	const [activePathArr, setActivePathArr] = useState([]);

	useEffect(() => {
		// Get the path from the location
		let path = location.pathname;

		// If using HashRouter, the path is in location.hash
		if (location.hash) {
			path = location.hash.substring(1);
		}

		// Remove leading slash if present
		if (path.startsWith("/")) {
			path = path.substring(1);
		}

		// Remove trailing slash if present
		if (path.endsWith("/")) {
			path = path.slice(0, -1);
		}

		// Split path into segments and filter out empty strings
		const segments = path.split("/").filter((segment) => segment !== "");
		setActivePathArr(segments);
	}, [location]);

	return activePathArr;
};

// Updated useCurrentPageObject function
export const useCurrentPageObject = (urlArray, menuData) => {
	const [currentPageObject, setCurrentPageObject] = useState(null);

	useEffect(() => {

		if (!urlArray || urlArray.length === 0 || !menuData) {
			setCurrentPageObject(null);
			return;
		}

		// Find the matching menu item by URL path
		const findPageObject = () => {
			// First, find the top-level menu item
			const topLevelSegment = urlArray[0];
			let foundTopItem = null;

			// Look for the matching top-level item
			for (let i = 0; i < menuData.length; i++) {
				const item = menuData[i];
				const itemPath = item.url.replace(/^\//, ""); // Remove leading slash

				if (itemPath === topLevelSegment) {
					foundTopItem = item;
					break;
				}
			}

			if (!foundTopItem) {
				console.log(
					`No matching top-level item found for "${topLevelSegment}"`,
				);
				return null;
			}

			// If we only have one segment, return the top-level page object
			if (urlArray.length === 1) {
				return foundTopItem.page || null;
			}

			// For deeper paths, traverse the sub-menus
			let currentItem = foundTopItem;
			let bestMatchPage = foundTopItem.page; // Start with the top-level page

			if (urlArray.length > 1 && currentItem.sub) {
				// Start from the second segment
				for (let i = 1; i < urlArray.length; i++) {
					const segment = urlArray[i];
					let found = false;

					// Look through the sub-items at the current level
					for (
						let j = 0;
						currentItem.sub && j < currentItem.sub.length;
						j++
					) {
						const subItem = currentItem.sub[j];
						// Extract the last part of the URL to match against the current segment
						const subItemPath = subItem.url.split("/").pop();

						if (subItemPath === segment) {
							currentItem = subItem;
							if (subItem.page) {
								bestMatchPage = subItem.page; // Update best match
							}
							found = true;
							break;
						}
					}

					if (!found) {
						// If we didn't find a match at this level, stop here
						break;
					}
				}
			}

			return bestMatchPage;
		};

		const pageObject = findPageObject();
		setCurrentPageObject(pageObject);
	}, [urlArray, menuData]);

	return currentPageObject;
};

